import React, { useState, Suspense } from 'react';
import { Box, IconButton, Tabs, Tab, Typography, Button, Paper, Divider, Snackbar, Alert } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import InventoryIcon from '@mui/icons-material/Inventory';
import TimelineIcon from '@mui/icons-material/Timeline';
import CloseIcon from '@mui/icons-material/Close';
import NotesGrid from './Lazy/LazyNotesGrid';
import PurchaseOrdersDisplay from './Lazy/LazyPurchaseOrdersDisplay';
import GanttDisplay from './Lazy/LazyGanttDisplay';

const ProjectNotes = ({ onClose, rowData }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleBack = () => {
    onClose();
  };

  return (
    <Box
      sx={{
        width: '100%',
        margin: '0 auto',
        backgroundColor: '#fff',
        boxShadow: '0px 2px 6px rgba(0,0,0,0.1)',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: 4,
        position: 'relative',
      }}
    >
      {/* Back Button */}
      <Button
        variant="contained"
        onClick={handleBack}
        startIcon={<ArrowBackIcon />}
        sx={{
          position: {
            xs: 'static',
            md: 'static',
            lg: 'absolute',
          },
          top: 16,
          left: 16,
          mb: {
            xs: 2,
            md: 0,
          },
        }}
      >
        Back
      </Button>

      {/* Header Section */}
      <Typography variant="h6" sx={{ fontWeight: 'bold', textAlign: 'center', color: '#333' }}>
        Project Information: {rowData?.name || 'N/A'}
      </Typography>

      <Divider />

      {/* Tabs */}
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
        sx={{
          '& .MuiTab-root': {
            minWidth: '180px',
            fontSize: '16px',
            padding: '12px 20px',
            textTransform: 'none',
          },
          '& .MuiTabs-indicator': {
            height: '4px',
            borderRadius: '2px',
          },
        }}
      >
        <Tab icon={<NoteAddIcon />} label="Add Notes" iconPosition="start" />
        <Tab icon={<InventoryIcon />} label="Purchase Orders" iconPosition="start" />
        <Tab icon={<TimelineIcon />} label="Purchase Order Gantt" iconPosition="start" />
      </Tabs>

      {/* Content Section */}
      <Paper
        elevation={0}
        sx={{
          minHeight: '400px',
          overflowY: 'auto',
          flexGrow: 1,
          backgroundColor: '#fff',
        }}
      >
        {activeTab === 0 && (
          <NotesGrid notes={rowData?.activities || []} projectId={rowData?.projectId} projectData={rowData} />
        )}
        {activeTab === 1 && <PurchaseOrdersDisplay purchaseOrders={rowData?.purchaseOrders || []} />}
        {activeTab === 2 && (
          <Suspense fallback={<Typography>Loading Gantt chart...</Typography>}>
            <GanttDisplay purchaseOrders={rowData?.purchaseOrders || []} />
          </Suspense>
        )}
      </Paper>

      {/* Snackbar Alert */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          severity="error"
          variant="filled"
          onClose={() => setOpenSnackbar(false)}
          sx={{ width: '100%' }}
          action={
            <IconButton size="small" color="inherit" onClick={() => setOpenSnackbar(false)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        >
          Please update and submit before leaving.
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ProjectNotes;
